export enum Issuer {
    JWT = 'JWT',
    HMAC = 'HMAC',
}
